import * as React from 'react';
import { ModuleProps } from 'src/utils/module-util';

import { CTAModuleMap } from './cta-module-map';

export interface CTAModuleProps extends ModuleProps {
  mccidData?: {
    link?: string;
    templateType?: string;
    campaignUrl?: string;
    mainUrl?: string;
    referrerId?: string;
  };
}

export const CTAModuleComponent = (props: CTAModuleProps) => {
  const component = CTAModuleMap;

  if (!component) {
    return null;
  }

  return React.createElement(component as any, props);
};
